import React, { useState } from 'react'
import { connect } from 'react-redux'
import CustomButton from "../common/CustomButton"
import { addGallery } from '../../actions/galleryActions'

const AddGallery = ({ ...props }) => {
  const [source, setSource] = useState('')
  const [type, setType] = useState({ value: 'IMAGE', error: null })
  const [galleryType, setGalleryType] = useState({ value: 'anand-workshop', error: null })

  const handleChange = (event, calledFor) => {
    let tempValue = { value: event.target.value, error: '' }
    if (!tempValue.value) {
      tempValue = { value: event.target.value, error: null }
    }
    switch (calledFor) {
      case 'Type':
        setType(tempValue)
        break
      case 'GalleryType':
        setGalleryType(tempValue)
        break
      case 'Source':
        let reader = new FileReader()
        let file = document.querySelector('input[type=file]').files[0]
        reader.readAsDataURL(file)
        setTimeout(
          () => {
            setSource(reader)
          }, 1500)
        break
    }
  }

  const handleSave = () => {
    const requestBody = {
      source: source.result,
      type: type.value,
      galleryType: galleryType.value
    }
    props.addGallery(requestBody)
  }

  return <>
    <div className="container">
      <div className="row justify-content-center text-center">
        <div className="col-lg-8 shadow-lg p-3 mb-5 bg-body rounded">
          <h3 className="text-dark main-title-border mb-3">Add Photo </h3>
          <div className="">
            <input
              divClassName="form-group pb-3"
              type="file"
              accept={type === "IMAGE" ? "image/png, image/jpg, image/jpeg" : "video/mp4, video/mpeg"}
              placeholder="Gallery Image"
              onChange={(e) => handleChange(e, 'Source')}
              inputClassName="form-control"
              id="image"
              required="required"
            />
          </div>
          <div className=" pb-3 mt-3">
            <select className="text-left d-block addproduct-category" placeholder="Select Type" onChange={(e) => handleChange(e, 'Type')}>
              <option value="IMAGE">Image</option>
              <option value="VIDEO">Video</option>
            </select>
          </div>
          <div className=" pb-3">
            <select className="text-left d-block addproduct-category" placeholder="Select Type" onChange={(e) => handleChange(e, 'GalleryType')}>
              <option value="anand-workshop">Anand Workshop</option>
              <option value="stem-india">Stem India</option>
              <option value="technoxian">Technoxian</option>
            </select>
          </div>
          <div className="col-lg-12 d-flex justify-content-center mt-4">
            <CustomButton
              divClassName='pb-2 w-25'
              className='btn blue-button w-100 font-weight-bold mt-2'
              onClick={handleSave}
              text='Save'
              disabled={!type.value || type.error || !source}
            />
          </div>
        </div>
      </div>
    </div>
  </>
}

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps, { addGallery })(AddGallery)